// src/components/PostLoginRedirector.jsx
import { useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function PostLoginRedirector({ user }) {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const target = sessionStorage.getItem("postLoginRedirect");
    if (!target) return;
    if (!user) return; // only after auth

    // Only fire when we’re on /login or we got bounced to /
    if (location.pathname === "/login" || location.pathname === "/") {
      sessionStorage.removeItem("postLoginRedirect");
      navigate(target, { replace: true });
    }
  }, [user, location.pathname, navigate]);

  return null;
}
